// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"xTpfJ","rc-tabs-tab":"rZGyB","rc-tabs-tab-active":"Mx+41","tip":"_2e9dC","tip-label":"aSNa6","tip-group":"YIPj1","back":"-KS18","back-container":"gCq+f"};